module.exports = __webpack_public_path__ + "img/setting-treatment-desktop-fr.eefee098.png";